import QuickStore from "@/stores/quickCutStore";
import {
  initISencesItem,
  toIndexGetInitTitleTextSetting,
} from "@/stores/mixCutDetailStore/init";
import useMixCutDetailSave from "./useMixCutDetailSave";
import { ITitle, ITitleItem } from "@/stores/mixCutDetailStore/type/title";
import useMixCutDetail from "./useMixCutDetail";
import ConfigStore from "@/stores/mixedConfig/index";
import { v4 as uuid } from "uuid";
import {bindingVideo} from "@/services/mixCutDetail/mixCutDetail";
import {useParams} from "react-router-dom";
import useMaterialPlayInfo from "@/useStore/quickCut/useMaterialPlayInfo";
import useVideoGroup from "@/useStore/quickCut/useVideoGroup";
import {IMaterialDetail} from "@/services/createSpace/graphQ/getSimpleMedia";
import {IMaterialFile} from "@/stores/mixCutDetailStore/type";
const { handleSaveMixCutDetailSave } = useMixCutDetailSave();
import {
  batch_download,
} from "@/services/createSpace/material";
export interface useParseScriptReturn {
  parseCutsomScript: (data: string) => void;
  parseHotScipt: (data: string) => void;
}

const useParseScript = (): useParseScriptReturn => {
  const { id } = useParams();
  const { handleSaveMixCutDetailSave } = useMixCutDetailSave();
  const { handleGetOriginJson } = useMixCutDetail();
  const { handleMaterialItemAdd } = useMaterialPlayInfo();
  const {
    handleProjectVideoChange,
  } = useVideoGroup();

  const handleUplodaMaterialData = (
    e: IMaterialDetail[],
    sences: IMaterialFile[],
  ): IMaterialFile[] => {
    return [
      ...e
        .map((item) => {
          return {
            id: item.id,
            clip_id: Math.floor(Date.now() + Math.random() * 10000),
            media_id: item.media_id,
            type: item.type,
            width: item.width,
            height: item.height,
            start: 0,
            duration: item.duration,
            is_cropped: false,
            speed: 1 as const,
          };
        })
    ];
  };

  // 自定义脚本导入
  const parseCutsomScript = async (data: string) => {
    try {
      const arr = JSON.parse(data);
      if (!Array.isArray(arr) || arr.length === 0) return;
      arr.sort((a, b) => a.key - b.key);

      const scenes = await Promise.all(arr.map(async (item) => {
        const materials = item.materials || [];
        if (materials.length > 0) {
          const media_ids = materials.map(m => m.media_id);
          try {
            const res = await batch_download({ media_id: media_ids });
            const items = res?.data?.items || [];
            const idToCover = Object.fromEntries(items.map(i => [i.media_id, i.cover]));
            const idToUrl = Object.fromEntries(items.map(i => [i.media_id, i.url]));
            materials.forEach((mat) => {
              handleMaterialItemAdd(mat.id, {
                url: idToUrl[mat.media_id],
                cover: idToCover[mat.media_id],
              });
            });
          } catch (err) {
            // 可选：错误处理
            console.error('batch_download error:', err);
          }
        }
        return {
          id: uuid(),
          name: item?.storyboardName?.[0]?.content?.[0]?.text || '',
          materials: materials.map((li) => ({
            id: li.id,
            clip_id: Math.floor(Date.now() + Math.random() * 10000),
            media_id: li.media_id,
            type: li.type,
            width: li.width,
            height: li.height,
            start: 0,
            duration: li.duration,
            is_cropped: false,
            speed: 1,
          })),
          material_mute: true,
          type: 2,
          duration: null,
        };
      }));
      QuickStore.quickcutData.scenes = scenes;
      try {
        const ids = scenes.map((item) => item.materials.map((li) => li.id)).flat();
        await bindingVideo(id, ids);
      } catch (e) {
        console.log(e);
      }
      handleSaveMixCutDetailSave();
      return handleGetOriginJson();
    } catch (err) {
      console.error('parseCutsomScript error:', err);
    }
  };

  // 爆款脚本导入
  const parseHotScipt = async (data: string) => {
    const obj = JSON.parse(data);
    if (obj.section?.length > 0) {
      QuickStore.quickcutData.scenes = obj.section.map(item => {
        return {
          id: uuid(),
          name: item.title,
          materials: [],
          material_mute: true,
          type: 2,
          duration: null
        }
      })
    }
    handleSaveMixCutDetailSave();
  };

  return {
    parseCutsomScript,
    parseHotScipt,
  };
};

export default useParseScript;
